import rapidElearningDetailsLocale from './en.json'

const en = {
  rapidElearningDetails: rapidElearningDetailsLocale,
}

export default en
